import { api } from '@/lib/api';
import type { MaintenanceEvent, MaintenanceEventInput } from './types';

export async function listMaintenanceEvents(accountId?: string): Promise<MaintenanceEvent[]> {
  return api.get<MaintenanceEvent[]>('/v4/maintenance-events', accountId ? { account_id: accountId } : undefined);
}

export async function getMaintenanceEvent(id: string): Promise<MaintenanceEvent> {
  return api.get<MaintenanceEvent>(`/v4/maintenance-events/${id}`);
}

export async function createMaintenanceEvent(input: MaintenanceEventInput): Promise<MaintenanceEvent> {
  return api.post<MaintenanceEvent>('/v4/maintenance-events', input);
}

export async function updateMaintenanceEvent(
  id: string,
  patch: Partial<MaintenanceEventInput>,
): Promise<MaintenanceEvent> {
  return api.put<MaintenanceEvent>(`/v4/maintenance-events/${id}`, patch);
}

export async function deleteMaintenanceEvent(id: string): Promise<void> {
  await api.delete(`/v4/maintenance-events/${id}`);
}

export async function runMaintenanceEventNow(id: string): Promise<MaintenanceEvent> {
  return api.post<MaintenanceEvent>(`/v4/maintenance-events/${id}/run`, {});
}
